<div class="bmc-user-groups-list" *ngIf="menuOptions">
    <div class="bmc-user-groups-list__create bz-space--stack-m" *ngIf="menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageUserGroup]]">
        <button type="button" class="bmc-user-groups-list__create__button bz-space--stack-m bz-btn bz-btn--m" (click)="newUserGroupAction()">
            <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-user-group'" [size]="16">
            </bzg-icon>
            <span>
                {{'USER_GROUPS.CREATE_NEW_USER_GROUP' | translate}}
            </span>
        </button>
    </div>
    <div class="bmc-user-groups-list__title bz-space--stack-m">
        <h4>{{'USER_GROUPS.USER_GROUPS_LIST' | translate}}</h4>
        <bzg-icon *ngIf="!deleteActivated && menuOptions[userGroupMenuOptions[userGroupMenuOptions.ManageUserGroup]]" class="bmc-user-groups-list__delete-icon" [nameIcon]="'icon-delete'"
                  [size]="16" (click)="deleteActivated = true">
        </bzg-icon>
        <div *ngIf="deleteActivated" class="bmc-user-groups-list__delete-buttons">
            <bzg-button-secondary class="bz-space--inline-s" [size]="'s'" (click)="cancelDeletion()">{{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
            <bzg-button-secondary [icon]="'icon-delete'" [size]="'s'" (click)="showDeleteConfirmation()" [disabled]="deletetionArray.length === 0">
                {{'GLOBAL.DELETE' | translate}}
            </bzg-button-secondary>
        </div>
    </div>
    <div class="bmc-user-groups-list__search-box bz-border-radius--m bz-space--stack-m">
        <bzg-input [placeholder]="('USER_GROUPS.SEARCH_BY' | translate)" class="bmc-user-groups-list__search-box__text" name="search-box"
            [(ngModel)]="searchValue" actionIcnPosition="right">
            <bzg-icon nameIcon="icon-search"></bzg-icon>
        </bzg-input>
    </div>
    <ul class="bmc-user-groups-list__items">
        <li class="bmc-user-groups-list__item bz-space--inset-squish-m bz-space--stack-s bz-shadow--xs bz-border-radius--m" 
            [ngClass]="{'bz-color-bg--theme-100': (userGroup === selectedUserGroup && !deleteActivated), 'bmc-user-groups-list__item--on-delete': deleteActivated}" 
            *ngFor="let userGroup of (userGroupsList$ | async) | searchBy : searchValue : ['displayName']"
            (click)="setCurrentUserGroup(userGroup)">
            <bzg-checkbox *ngIf="deleteActivated" (change)="addOrRemoveFromDeletionList(userGroup.id, $event)"></bzg-checkbox>
            <div class="bmc-user-groups-list__item__texts" [ngClass]="{'bmc-user-groups-list__item__texts--on-delete': deleteActivated}">
                <h5 class="bmc-user-groups-list__item__name bz-font-weight--semibold" [ngClass]="{'bz-space--stack-s': (userGroup.description && userGroup.description !== '')}">{{userGroup.displayName}}</h5>
                <h5 class="bmc-user-groups-list__item__description bz-font-size--body-small">{{userGroup.description}}</h5>
            </div>
            <svg class="bz-icn bz-icon-svg--16">
                <use href="#icon-arrow-right-bold"></use>
            </svg>
        </li>
    </ul>
</div>
